import AboutImg from "../assets/about.png";
import { motion } from "framer-motion";

export default function About() {
  return (
    <section
      id="about"
      className="relative px-6 md:px-10 lg:px-20 py-20 md:py-28 bg-gradient-to-b from-black via-[#0b0d12] to-[#090c10] text-white overflow-hidden"
    >
      {/* Main Content Container */}
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-16">
        {/* Text Section */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="w-full md:w-1/2 space-y-6 text-left"
        >
          <motion.h1
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="text-4xl md:text-5xl lg:text-6xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-cyan-300"
          >
            Who We Are
          </motion.h1>

          <p className="text-lg md:text-xl text-gray-300">
            <motion.span whileHover={{ scale: 1.05 }} className="inline-block">
              Vcode Freelance
            </motion.span>{" "}
            is a team of expert developers, designers, and strategists crafting
            high-performance, scalable, and AI-powered web solutions. 🚀
          </p>

          <p className="text-lg md:text-xl text-gray-300">
            We specialize in{" "}
            <motion.span
              whileHover={{ scale: 1.05, rotate: 5 }}
              className="text-blue-400"
            >
              React.js, Tailwind CSS, TypeScript
            </motion.span>{" "}
            and{" "}
            <motion.span
              whileHover={{ scale: 1.05, rotate: -5 }}
              className="text-cyan-400"
            >
              Node.js, Express.js, MongoDB, AWS
            </motion.span>{" "}
            to create seamless user experiences.
          </p>

          <p className="text-lg md:text-xl text-gray-300">
            From startups to enterprises, we help businesses{" "}
            <motion.span
              whileHover={{ scale: 1.05, rotate: 3 }}
              className="text-green-400"
            >
              code, scale, and innovate
            </motion.span>{" "}
            with cutting-edge technologies.
          </p>

          <motion.a
            href="#contact"
            whileHover={{
              scale: 1.1,
              boxShadow: "0px 0px 25px #00C9FF",
            }}
            className="mt-4 inline-block px-6 py-3 text-lg font-semibold bg-blue-500 text-white rounded-full shadow-lg hover:bg-blue-600 transition duration-300"
          >
            Let’s Work Together
          </motion.a>
        </motion.div>

        {/* Image Section */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="w-full md:w-1/2 flex justify-center"
        >
          <div className="relative p-6 rounded-xl bg-white/10 backdrop-blur-lg shadow-xl border border-white/10 transform hover:scale-105 transition duration-500 w-full max-w-md">
            <motion.img
              src={AboutImg}
              alt="About Vcode Freelance"
              className="rounded-xl w-full"
              animate={{ y: [0, -8, 0] }}
              transition={{ repeat: Infinity, duration: 3, ease: "easeInOut" }}
              onContextMenu={(e) => e.preventDefault()}
              draggable="false"
            />
          </div>
        </motion.div>
      </div>

      {/* Floating Animated Shapes */}
      <motion.div
        animate={{ x: [0, 15, -15, 0], rotate: [0, 10, -10, 0] }}
        transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
        className="absolute bottom-10 right-10 w-16 h-16 bg-blue-500/30 rounded-full blur-2xl"
      />
      <motion.div
        animate={{ y: [0, -20, 20, 0], rotate: [0, -5, 5, 0] }}
        transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
        className="absolute top-10 left-10 w-12 h-12 bg-cyan-400/30 rounded-full blur-2xl"
      />
    </section>
  );
}
